import { senserData } from './shared/state';

export default {
  namespaced: true,
  modules: {
    senserData
  }
};
